import Swiper from '../../../../../vendor/swiper/swiper-bundle.mjs';

export default class LogoSlider {
    constructor($el) {
        this.$el = $el;

        this.slide = this.slide.bind(this);
        this.slide();
    }

    slide() {
        var swiper = new Swiper(this.$el.querySelector('[data-logo-slider]'), {
            spaceBetween: 25,
            slidesPerView: 1,
            slidesPerGroup: 1,
            centeredSlides: true,
            loop: true,
            watchOverflow: true,
            navigation: {
                nextEl: this.$el.querySelector('[data-logo-list-arrow-next]'),
                prevEl: this.$el.querySelector('[data-logo-list-arrow-prev]'),
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    slidesPerGroup: 1,
                },
                992: {
                    slidesPerView: 'auto',
                    slidesPerGroup: 1,
                    centeredSlides: false,
                },
            },
        });
    }
}
